import plateNumber from '~/assets/icons/plate_number_2.svg';
import { ScrollContainer } from '~/components/ui/ScrollContainer';
import { SectionHeading } from '~/components/ui/SectionHeading';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { StoragePlate } from '../StoragePlate';
import { StyledContainer, StyledList } from './StorageTab.styled';

const StorageTab: React.FC = () => {
	const storedNumberPlates = useObservable(
		rage.vehicleNumberPlates.getStoredNumberPlates(),
	);

	return (
		<StyledContainer>
			<SectionHeading text={'Номера в хранилище'} icon={plateNumber} />
			{storedNumberPlates.length === 0 && (
				<Text
					style={{
						marginTop: 139,
						fontSize: 16,
						fontWeight: 400,
						color: '#FFFFFF',
						opacity: 0.25,
						textAlign: 'center',
					}}
				>
					К сожалению, у вас нет
					<br />
					сохраненных номеров
				</Text>
			)}
			<ScrollContainer height={312}>
				<StyledList>
					{storedNumberPlates.map((item, index) => (
						<StoragePlate numberPlate={item} key={index} />
					))}
				</StyledList>
			</ScrollContainer>
		</StyledContainer>
	);
};

export { StorageTab };
